import { NextSeo } from 'next-seo';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { urlHostResolver } from '@/src/lib/utils';
import PlatformView from '@/src/views/platform/PlatformView';

export default function PlatformPage() {
  return (
    <AssembleLayout Layout={MainLayout} Component={PlatformView}>
      <NextSeo
        title="Plataforma"
        description="Com baixo investimento e rápida implantação, comece a vender online em uma plataforma customizada para venda de produtos e serviços educacionais"
        openGraph={{
          title: 'Plataforma',
          url: urlHostResolver('/platform'),
        }}
      />
    </AssembleLayout>
  );
}
